const STUDY_LEVELS = {
    GET_TO_KNOW_YOUR_CANDIDATE: 0,
    TALENT_ANALYTICS_FIT: 1,
    TALENT_ANALYTICS_RISK: 3,
    TALENT_INSIGHTS: 2,
};

module.exports = STUDY_LEVELS;



//////////////////
// WEBPACK FOOTER
// ./src/constants/study-levels.js
// module id = 397
// module chunks = 58